module.exports = __webpack_public_path__ + "img/zlglogo.f1331062.png";